import { inspect } from 'util';

// Server side redux action logger
export const createLogger = (shouldLog: boolean) => {
    return () => (next: Function) => (action: any) => {
        if (!shouldLog) {
            return next(action);
        }

        const formattedPayload = inspect(action.payload, { colors: true });
        // eslint-disable-next-line no-console
        console.log(` * ${action.type}: ${formattedPayload}`);
        return next(action);
    };
};
